import CustomersLayout from 'layouts/Customers.layout'

const customersRoutesWithCustomersLayout = [
  {
    element: <CustomersLayout />,
    children: [
      {
        index: true,
        handle: {title: 'All Contacts'},
        lazy: () => import('components/pages/Customers/Contacts'),
      },
      {
        path: 'segment/:segmentId',
        handle: {title: 'Contacts'},
        lazy: () => import('components/pages/Customers/Contacts'),
      },
      {
        path: 'companies',
        handle: {title: 'All Companies'},
        lazy: () => import('components/pages/Customers/Companies'),
      },
      {
        path: 'companies/segment/:segmentId',
        handle: {title: 'All Companies'},
        lazy: () => import('components/pages/Customers/Companies'),
      },
    ],
  },
]

const customersRoutesWithoutCustomersLayout = [
  {
    path: ':id',
    handle: {title: 'Contact Details'},
    lazy: () => import('components/pages/Customers/Customer'),
  },
  {
    path: 'companies/:id',
    handle: {title: 'Company Details'},
    lazy: () => import('components/pages/Customers/Company'),
  },
]

const customersRoutes = [
  {
    path: 'customers',
    handle: {title: 'Customers'},
    children: [...customersRoutesWithCustomersLayout, ...customersRoutesWithoutCustomersLayout],
  },
]

export default customersRoutes
